module.exports = __webpack_public_path__ + "static/media/4.5e15c3cc.svg";